import { ReminderKey } from './reminder.shared.model.js';
export var AppTracker = /*#__PURE__*/function (AppTracker) {
  AppTracker[AppTracker["MENS_QUANTITY"] = 1] = "MENS_QUANTITY";
  AppTracker[AppTracker["CM_CONSISTENCY"] = 2] = "CM_CONSISTENCY";
  AppTracker[AppTracker["CM_QUANTITY"] = 3] = "CM_QUANTITY";
  AppTracker[AppTracker["LIBIDO"] = 4] = "LIBIDO";
  AppTracker[AppTracker["PAIN"] = 5] = "PAIN";
  AppTracker[AppTracker["SKIN"] = 6] = "SKIN";
  AppTracker[AppTracker["MOOD"] = 7] = "MOOD";
  AppTracker[AppTracker["MORE_SEX"] = 8] = "MORE_SEX";
  AppTracker[AppTracker["NOTES"] = 9] = "NOTES";
  AppTracker[AppTracker["SEX"] = 10] = "SEX";
  AppTracker[AppTracker["LH_TEST"] = 11] = "LH_TEST";
  AppTracker[AppTracker["PREG_TEST"] = 12] = "PREG_TEST";
  AppTracker[AppTracker["SLEEP"] = 13] = "SLEEP";
  AppTracker[AppTracker["BREASTFEEDING"] = 14] = "BREASTFEEDING";
  AppTracker[AppTracker["BOTTLE_FEEDING"] = 15] = "BOTTLE_FEEDING";
  AppTracker[AppTracker["PUMPING"] = 16] = "PUMPING";
  AppTracker[AppTracker["LIFESTYLE"] = 17] = "LIFESTYLE";
  AppTracker[AppTracker["EXTERNAL_FACTOR"] = 18] = "EXTERNAL_FACTOR";
  return AppTracker;
}(AppTracker || {});
export const reminderByAppTracker = {
  [AppTracker.LH_TEST]: ReminderKey.checkLH,
  [AppTracker.MOOD]: ReminderKey.pms,
  [AppTracker.PREG_TEST]: ReminderKey.startTesting
};
export const appTrackerByReminder = Object.fromEntries(Object.entries(reminderByAppTracker).map(([key, value]) => [value, Number(key)]));